/**
 * kan-107: upload-time check of the standard temp-billing file name,
 * "REALREPP - YYYYMMDD - FILETYPE.xlsx". It only WARNS — the upload still goes
 * through, and the server reads the report date out of the name loosely anyway.
 * The point is to catch drift ("REALREPP - 20260909- RP.xlsx") and a file picked
 * under the wrong File Type before it lands on the list.
 */

export const TEMP_BILLING_STANDARD_NAME = 'REALREPP - YYYYMMDD - FILETYPE.xlsx'

// FILETYPE code per File Type select value (TEMP_BILLING_IMPORTS_OPTIONS).
export const TEMP_BILLING_FILE_TYPE_CODE: Record<string, string> = {
  RECRUITER_PROFIT_SUMMARY: 'RP',
  A_R_AGING_BY_RECRUITER: 'AR',
  RECRUITER_AGENCY_WEEKLY_ACTIVITY: 'WA',
}

const STANDARD_NAME = /^REALREPP - (\d{4})(\d{2})(\d{2}) - ([A-Z]+)\.xlsx$/i

/** Returns a warning to show under the file name, or null when it is standard. */
export function tempBillingFileNameWarning(fileName?: string | null, reportType?: string | null): string | null {
  const name = fileName?.trim()
  if (!name) return null
  // /i is only there for the ".xlsx"/".XLSX" extension; the prefix must be upper-case.
  const match = STANDARD_NAME.exec(name)
  if (!match || !name.startsWith('REALREPP')) {
    return `This file name doesn't follow the standard "${TEMP_BILLING_STANDARD_NAME}".`
  }
  const [, y, m, d, rawCode] = match
  if (!isCalendarDate(+y, +m, +d)) {
    return `"${y}${m}${d}" in the file name isn't a valid YYYYMMDD date.`
  }
  const code = rawCode.toUpperCase()
  const knownCodes = Object.values(TEMP_BILLING_FILE_TYPE_CODE)
  if (!knownCodes.includes(code)) {
    return `"${rawCode}" isn't a known file type. Expected one of ${knownCodes.join(', ')}.`
  }
  const expected = reportType ? TEMP_BILLING_FILE_TYPE_CODE[reportType] : undefined
  if (expected && expected !== code) {
    return `The file name says "${code}" but the selected File Type expects "${expected}".`
  }
  return null
}

function isCalendarDate(y: number, m: number, d: number): boolean {
  if (y < 2000 || y > 2099 || m < 1 || m > 12 || d < 1) return false
  return d <= new Date(Date.UTC(y, m, 0)).getUTCDate()
}
